import { render, staticRenderFns } from "./registration-dialog.vue?vue&type=template&id=d15299ee&"
import script from "./registration-dialog.vue?vue&type=script&lang=js&"
export * from "./registration-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports